import React from "react";

import { StyledSkeleton } from "./styles";

export const Skeleton: React.FC = () => <StyledSkeleton>loading...</StyledSkeleton>;
